import {
  isStartPlacementAtom,
  pitchCropAtom,
  pitchMarkerColouringModeAtom,
  pitchOrientationAtom,
  showArrowsAtom,
} from '@/atoms/visualisation';
import { PITCH_COLOURING_MODES, PITCH_CROP, PITCH_ORIENTATION } from '@/consts/visualisations';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';
import { useSetAtomFromParams } from '../queryParams/useSetAtomFromParams';

export const useSetPitchDisplaySettings = () => {
  useSetAtomFromParams(
    pitchMarkerColouringModeAtom,
    ConfigDisplaySettingKey.PITCH_MARKER_COLOURING_MODE,
    PITCH_COLOURING_MODES,
  );

  useSetAtomFromParams(isStartPlacementAtom, ConfigDisplaySettingKey.IS_START_PLACEMENT, ['true', 'false'], false);

  useSetAtomFromParams(pitchCropAtom, ConfigDisplaySettingKey.PITCH_CROP, PITCH_CROP);

  useSetAtomFromParams(pitchOrientationAtom, ConfigDisplaySettingKey.PITCH_ORIENTATION, PITCH_ORIENTATION);

  useSetAtomFromParams(showArrowsAtom, ConfigDisplaySettingKey.SHOW_ARROWS, ['false', 'true'], false);
};
